import { memo } from "react";
import { GRID_ACTIONS_COLUMN_TYPE, type GridRowParams } from "@mui/x-data-grid";
import { useResetState } from "hooks";
import { TableGridMode } from "consts/table";
import { Filters, MenuItem } from "consts/openBanking";
import { FilterVariant } from "consts/filters";
import {
    selectOpenBankingResourceSlice,
    selectIsOpenBankingResourceLoading,
    selectIsOpenBankingResourceUninitialized
} from "features/openBanking/selectors";
import { resetBankingSdkRecipientsState } from "features/openBanking/slice";
import BankingSDKRecipientsToolbar from "./BankingSDKRecipientsToolbar";
import BankingSDKRecipientsDetail from "./BankingSDKRecipientsDetail";
import useBankingSDKRecipients from "./useBankingSDKRecipients";
import {
    CreateBankingSDKRecipient,
    DeleteBankingSDKRecipient
} from "./actions";
import { OpenBankingResource, EditOpenBankingResource } from "../shared";

const BankingSDKRecipients = () => (
    <OpenBankingResource
        BreadcrumbsProps={{
            heading: 'Open Banking Recipients',
            action: (
                <CreateBankingSDKRecipient />
            )
        }}
        ResourceProps={{
            name: 'Open Banking Recipient',
            useResource: useBankingSDKRecipients,
            mode: TableGridMode.OpenBankingBankingSDKRecipients,
            resetState: useResetState(resetBankingSdkRecipientsState),
            selectIsTableUninitialized: selectIsOpenBankingResourceUninitialized(MenuItem.BankingSDKRecipients),
            selectIsTableLoading: selectIsOpenBankingResourceLoading(MenuItem.BankingSDKRecipients),
            selectTableDataSlice: selectOpenBankingResourceSlice(MenuItem.BankingSDKRecipients),
            Toolbar: BankingSDKRecipientsToolbar,
            Detail: BankingSDKRecipientsDetail,
            columns: [
                {
                    field: GRID_ACTIONS_COLUMN_TYPE,
                    type: GRID_ACTIONS_COLUMN_TYPE,
                    getActions: (params: GridRowParams) => [
                        <EditOpenBankingResource
                            key='edit'
                            {...params}
                        />,
                        <DeleteBankingSDKRecipient
                            key='delete'
                            {...params}
                        />
                    ]
                }
            ],
            filterTypes: new Map<FilterVariant, string[]>([
                [FilterVariant.MultiOption, [
                    Filters.country,
                    Filters.accountCurrency
                ]]
            ]),
        }}
    />
);

export default memo(BankingSDKRecipients);
